import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { routeGuardBlocked } from "../Actions/shared";

const mapStateToProps = (state) => ({
  state,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchRouteGuardBlocked: (path) => dispatch(routeGuardBlocked(path)),
});

const GuardedRoute = ({
  component: Component,
  exact = false,
  path,
  guards,
  state,
  dispatchRouteGuardBlocked,
  redirectComponent: RedirectComponent,
  children,
}) => {
  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        if (
          guards.every((guard) =>
            typeof guard === "function" ? guard(state) : guard,
          )
        ) {
          return (
            <>
              <Component {...props} />
              {children}
            </>
          );
        }

        dispatchRouteGuardBlocked(path);
        return <RedirectComponent />;
      }}
    />
  );
};

GuardedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
    .isRequired,
  path: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  guards: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  ).isRequired,
  redirectComponent: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.elementType,
  ]),
};

export default connect(mapStateToProps, mapDispatchToProps)(GuardedRoute);
